import styled from "styled-components";
import Button from "../../common/components/button/Button";
import { media } from "../../common/components/ui/utils";

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 1.5rem;
  box-sizing: content-box;
  max-width: 600px;
  margin: 0 auto;
  
`;

const Tab = styled(Button)`
  width: calc(95%/3);
  //width: 48%;
  background-color: ${props => props.theme.Tab_background_color};
  border-width: 1px;
  border-style: solid;
  border-radius: 0;
  border: 0;
  padding: 1.25em 0.5em;
  font-family: "Roboto";
  font-weight: bold;
  font-size: 0.75rem;
  border-color: ${props => props.theme.Tab_border_color};
  color: ${props => props.theme.Tab_color};
  text-transform: uppercase;
  &:last-of-type {
    border-right: 0;
    border-top-right-radius: 3px;
  }
  &:first-of-type {
    border-top-left-radius: 3px;
  }
  &:nth-of-type(2) {
    width: calc(95%/3 + 5%);
  }
  
  ${media.phoneWide`
    width: calc(100%/3);
    &:nth-of-type(2) {
      width: calc(100%/3);
    }
  `}
  ${media.tabletNarrow`
    font-size: 0.875rem;
    padding: 1.25em 1.5em; 
    
  `} &.selected {
    background-color: ${props => props.theme.TabSelected_background_color};
    border-color: ${props => props.theme.TabSelected_border_color};
    color: ${props => props.theme.TabSelected_color};
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
  }
`;

export default {
  Container,
  Tab
};



// WEBPACK FOOTER //
// ./src/modules/search/ui/SearchTabs.js